import { Controller, FieldValues, FieldPath, Control, PathValue } from "react-hook-form";

import { RadioGroup, RadioGroupItem, RadioGroupProps } from "../ui/radio-group";
import { cn } from "../../lib/utils";


type RadioItemDetail = {
    id: string;
    value: string;
    label: string;
}

interface ControlledRadioGroupProps<T extends FieldValues> extends RadioGroupProps {
    name: FieldPath<T>;
    control: Control<T>;
    items: RadioItemDetail[];
    defaultValue?: PathValue<T, FieldPath<T>>;
    isFilled?: boolean;
};

const ControlledRadioGroup = <T extends FieldValues>(props: ControlledRadioGroupProps<T>) => {
    const { control, name, items, defaultValue, isFilled, className, ...radioGroupProps } = props;
	return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field }) => (
                <RadioGroup
                    className={cn("flex flex-row", className)}
                    {...field}
                    {...radioGroupProps}
                    onValueChange={(value) => {
                        field.onChange(value);
                    }}
                >
                    {items.map(({id, value, label}) => (
                        <RadioGroupItem 
                            value={value} 
                            id={id} 
                            label={label} 
                            key={value} 
                            fillInside={isFilled}
                        />
                    ))}
                </RadioGroup>
            )}
        />
)};

export { ControlledRadioGroup };